// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_26KhE","details":"_3Md_x"};